import React, { useState } from 'react';
import { Competition } from '../../types/interfaces';
import { CompetitionRole, isHostAdminOrAbove } from '../../services/manageApi';
import config from '../../config/environment';
import ManageCompetitionAddAccessModal from '../ManageCompetitionAddAccessModal';
import ManageCompetitionAccessListModal from '../ManageCompetitionAccessListModal';
import ManageCompetitionAddHostModal from '../ManageCompetitionAddHostModal';
import ManageCompetitionTeamsModal from '../ManageCompetitionTeamsModal';
import NotificationComposerModal from '../NotificationComposerModal';
import ActionButton from './ActionButton';

type OpenModal = null | 'access-list' | 'add-access' | 'add-host' | 'notify' | 'teams';

const PeopleTab: React.FC<{ competition: Competition; role: CompetitionRole }> = ({ competition, role }) => {
  const [open, setOpen] = useState<OpenModal>(null);
  const close = () => setOpen(null);
  const canManageHosts = isHostAdminOrAbove(role);
  const showTeams = Boolean(config?.FEATURES?.TEAM_MODE_ENABLED) && competition.competition_mode === 'team';
  const competitionId = Number(competition.id);

  return (
    <>
      <section className="manage-section" data-tour="manage-people">
        <h3>People &amp; access</h3>
        <div className="manage-competition-actions__stack">
          <ActionButton label="View Access List" onClick={() => setOpen('access-list')} />
          <ActionButton label="View User/Team Submissions" disabled={!canManageHosts} onClick={() => setOpen('access-list')} />
          <ActionButton label="Add Access" onClick={() => setOpen('add-access')} />
          <ActionButton label="Add Hosts" disabled={!canManageHosts} onClick={() => setOpen('add-host')} />
          <ActionButton label="Send Notification" disabled={!canManageHosts} onClick={() => setOpen('notify')} />
          {showTeams && <ActionButton label="Manage Teams" disabled={!canManageHosts} onClick={() => setOpen('teams')} />}
        </div>
        {!canManageHosts && (
          <p className="manage-competition-actions__hint">
            Viewing submissions, adding hosts, sending notifications and managing teams require platform admin or host admin privilege.
          </p>
        )}
      </section>

      <ManageCompetitionAddAccessModal isOpen={open === 'add-access'} onClose={close} competitionId={competitionId} />
      <ManageCompetitionAccessListModal
        isOpen={open === 'access-list'}
        onClose={close}
        competitionId={competitionId}
        canViewAllSubmissions={canManageHosts}
        canViewScores={canManageHosts}
      />
      <ManageCompetitionAddHostModal isOpen={open === 'add-host'} onClose={close} competitionId={competitionId} />
      <ManageCompetitionTeamsModal isOpen={open === 'teams'} onClose={close} competition={competition} />
      <NotificationComposerModal
        isOpen={open === 'notify'}
        onClose={close}
        competitions={[competition]}
        fixedCompetitionId={competitionId}
        fixedCompetitionTitle={competition.title}
        allowScopeSelection={false}
        title="Send Competition Notification"
      />
    </>
  );
};

export default PeopleTab;
